<template>
	    <!-- 更改房态弹窗 -->
	<div v-if="data.isShow">
	    <div class="mask update-room">
	        <div class="e-modal small">
	            <div class="e-modal-title">更改房价 <i class="e-modal-close" @click="data.isShow=false"></i></div>
	            <div class="e-modal-date">{{data.PD|dateToDvd}} {{data.PD|dateWeek}}</div>
	            <div class="e-modal-body">
	                <div class="body-item">
	                	<span class="label">价格： </span>
	                	<label for="">
	                		<input type="text" v-model="data.AP" onKeyPress="if((event.keyCode<48 || event.keyCode>57) && event.keyCode!=46 )event.returnValue=false"   onkeyup="value=value.replace(/[\u4e00-\u9fa5]/g,'')"  @blur="data.AP=parseInt(data.AP*100)/100" /> 
	                			<!-- /\.\d\d$/.test(value) -->
	                			<!-- <span class="clear-input-btn-number" @click="data.AP=''" v-if="isClearBtnShow">x</span> -->
	                	</label>
	                </div>
	                <div class="body-item">
	                	<span class="label">取消： </span>
	                	<input type="radio" name="canCancel" v-model="canCancel" :value="true"/>
	                	<label for="" class="select-label pstRel" style="margin-right:0" >
	                    	<select name="" id="" v-model="data.CD" style="margin-right:0"  :disabled="!canCancel">
													<option value="0">当天</option>
													<option value="1">1</option>
													<option value="2">2</option>
													<option value="3">3</option>
													<option value="4">4</option>
													<option value="5">5</option>
													<option value="6">6</option>
													<option value="7">7</option>
													<option value="8">8</option>
													<option value="9">9</option>
													<option value="10">10</option>
													<option value="11">11</option>
													<option value="12">12</option>
													<option value="13">13</option>
													<option value="14">14</option>
													<option value="15">15</option>
	                      </select>
                     	</label>天
	                	<label class="select-label pstRel" for="" style="margin-right:0">
	                		<select name="" id="" v-model="data.CT" :disabled="!canCancel" style="margin-right:0">
	                			<option value="23:59">23:59</option>
	                			<option value="12:00">12:00</option>
	                			<option value="13:00">13:00</option>
	                			<option value="14:00">14:00</option>
	                			<option value="15:00">15:00</option>
	                			<option value="16:00">16:00</option>
	                			<option value="17:00">17:00</option>
	                			<option value="18:00">18:00</option>
	                			<option value="19:00">19:00</option>
	                			<option value="20:00">20:00</option>
	                			<option value="21:00">21:00</option>
	                			<option value="22:00">22:00</option>
	                			<option value="23:00">23:00</option>
	                		</select>
	                	</label>前取消
	                </div>
	                <div class="body-item">
	                	<span class="label"></span>
	                	<input type="radio" name="canCancel" v-model="canCancel" :value="false"/>
	                	<label for="checkbox42">
	                		<!-- <input type="checkbox" id="checkbox42" v-model="data.C" :disabled="canCancel" /> -->
	                		不可取消
	                	</label>
	                </div>
	            </div>
	            <div class="e-modal-footer">
	                <div class="long-btn save-btn" @click="save">保存</div>
	                <div class="long-btn cancel-btn" @click="data.isShow=false">取消</div>
	            </div>
	        </div>
	    </div>
    </div>
	
</template>
<script>
export default {
    name:'roomPriceSingle',
    props:{
    	cmData:{
    		type:Object,
    		default:function(){
    			return{}
    		}
    	},
    	rps:{
    		type:Object,
    		default:function(){
    			return{}
    		}
    	}
    },
    data(){
    	return{
    		data:{},
    		canCancel:false,
    		isClearBtnShow:false
    	}
    },
    watch:{
			cmData(val){
				this.data=val;

				if(this.data.S!='026001'){
					this.data.S='026002'
				}
				if(this.data.A!=true){
					this.data.A=false
				}
				if(!this.data.SC){
					this.data.SC=0
				}
				if(!this.data.O){
					this.data.O=false
				}
				this.canCancel=!this.data.C;

			}
    },
    methods:{
    	closeEdit(){
			this.data.isShow=false;
		
    	},
	  	save(){
    		var that=this;
    		var rps=this.rps;
    		var data=this.data;

    		if(!data.AP||data.AP<0){
    			that.error({ title: '提示', content: '价格不能小于0' });
    			return;
    		}

    		if(data.AP>100000000){
    			that.error({ title: '提示', content: '价格不能大于100000000' });
    			return;
    		}

	        var params={
	          HotelID: rps.HotelId,
	          RoomID: rps.RoomId,
	          RPID: rps.RatePlanId,
	          RateID: rps.RateId,
			  Currency:"CNY",
			  Date:data.PD,
			  Price:data.AP,
			  NotAllowCancel:!this.canCancel,
			  CutDay:data.CD||0,
			  CutTime:data.CT,
	        }
	    
	        // that.isSaving=true;
	        that.patchRequest({
	            url: that.Api.updatePriceSingle,
	            params: params
	        }).then(res => {
	            if (res&&res.IsSuccess) {
	            	that.$emit('initTable')
	            	that.data.isShow=false;

	            } else {
	                that.error({ title: '提示', content: '提交失败，请重新提交' });
	            }
	        });
	  	}

    },
    mounted(){
    	// this.data=this.cmData;

    }

}
</script>


// WEBPACK FOOTER //
// src/components/roomPrice/psComponent/roomPriceEdit/RoomPriceSingle.vue